import $ from 'jquery'
import mod_consultation from "@/store/mods/clinique/consultations.js"

export default {
    name: 'all-types-cons',
    components: {},
    props: [],
    data() {
        return {
            picked: {},
            list_type_consultations: []
        }
    },
    computed: {
        
    },
    mounted() {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);
        this.selectTypeConsultations()
    },
    methods: {
        confirmSelection() {
            this.$store.commit("SET_TYPE_CONS_SELECTED", this.picked)
            this.$store.commit("SET_TYPE_ACTION_SELECTED", "bon_consultation")
            this.$router.push({ name: 'choice-patient' })
        },

        selectTypeConsultations() {
            mod_consultation.getListeTypesConsultations().then((type_consultations) => {
                this.list_type_consultations = type_consultations
            })
        },
    }
}